<div class='modal-header' [ngSwitch]='dialogMode' (click)='$event.stopPropagation()'>
  <ng-container *ngSwitchCase='"CREATE"'>
    <div class="modal-title">
      <h4 class="mb-0">{{ 'TITLE.NEW_APP_ASSESSMENT' | translate }}</h4>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase='"DUPLICATE"'>
    <div class="d-flex flex-column">
      <h4 class='modal-title'>{{ "LABELS.DUPLICATE" | translate }}</h4>
      <span class="text-muted fst-italic small" *ngIf="duplicateAppAssessmentPayload?.payload?.name">
        {{duplicateAppAssessmentPayload?.payload?.name}}
      </span>
    </div>
  </ng-container>
</div>
<div class='modal-body' (click)='$event.stopPropagation()'>
  <ng-container *ngIf='formGroup && !loading'>
    <form [formGroup]='formGroup'>
      <div class='form-group' *ngIf='checkUsedField("name")'>
        <label class="form-label">{{ 'LABELS.NAME' | translate }} <span
          class='text-danger'>*</span>
        </label>
        <input type='text'
               autocomplete='off'
               formControlName='name'
               [maxLength]='128'
               class='form-control form-control-sm'
        >
      </div>

      <div class='form-group' *ngIf='checkUsedField("description")'>
        <label class="form-label">{{ 'LABELS.DESCRIPTION' | translate }}</label>
        <textarea
          autocomplete='off'
          formControlName='description'
          class='form-control form-control-sm'
          [rows]='5'
          aria-describedby='ptWInputHelp'>
          </textarea>
      </div>

      <div class='form-group'>
        <pt-input-text-conditional-checkbox
          [label]="'LABELS.INTERNAL_ID' | translate"
          [checkboxLabel]="'LABELS.DEFAULT_INTERNAL_ID' | translate"
          [cleanOnDisable]='true'
          [enableOnCheck]='false'
          [defaultCheckValue]='true'
          [controlName]="'internalId'"
          [activeValidatorsOnlyWhenEnabledInput]='true'
          formControlName='internalId'
          [validators]='[REQUIRED]'
          *ngIf='checkUsedField("internalId")'
        ></pt-input-text-conditional-checkbox>
      </div>

      <!--APPLICATION----------------------------------------------------------------->
      <ng-template #popContentApplicationContent class='p-0'>
        <pt-resource-navigation
          [title]="'TITLE.SELECT_APPLICATION' | translate"
          [data]='applications'
          [selectedResourceId]='selectedApplication?.id'
          (clickClose)='popContentApplication.close()'
          (clickItem)='selectApplication($event)'>
        </pt-resource-navigation>
      </ng-template>

      <div class='tree-selector' *ngIf='checkUsedField("applicationId")'>
        <label class="form-label">{{ 'LABELS.APPLICATION' | translate }} <span class='text-danger'>*</span>
        </label>
        <div class='input-group input-group-sm mb-3'>
          <div class='input-group-text'>
            <pt-icon [key]="'applications.svg'" [size]='14' [iconType]="'SVG'"></pt-icon>
          </div>
          <input type='text'
                 autocomplete='off'
                 formControlName='applicationId'
                 class='form-control form-control-sm form-readonly--custom'
                 [ngbPopover]='popContentApplicationContent'
                 [autoClose]="'outside'"
                 #popContentApplication='ngbPopover'
                 triggers='manual'
                 readonly
                 placement='top'
                 (click)='chooseApplication()'
                 placeholder="{{'PLACEHOLDERS.APPLICATION' | translate}}">
          <button type='button' class='btn-close tree-selector-clean font-10' aria-label='Close'
                  (click)='cleanApplication()'>
            <!--            <span aria-hidden='true'>&times;</span>-->
          </button>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf='loading'>
    <div class='loader-container'>
      <pt-loader></pt-loader>
    </div>
  </ng-container>
</div>

<div class='modal-footer' (click)='$event.stopPropagation()'>
  <button type='button' class='btn btn-primary btn-sm'
          [disabled]='formGroup?.invalid || loading'
          (click)='confirm(); $event.stopPropagation()'>
    <ng-container [ngSwitch]='dialogMode'>
      <ng-container *ngSwitchCase='"CREATE"'>
        {{ 'BUTTON.CREATE' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase='"DUPLICATE"'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </ng-container>
    </ng-container>
  </button>
  <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
          (click)='activeModal.close(false); $event.stopPropagation()'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>
